import api from "../../../api/flexapi";
export const GET_HDF_CONFIGURATION_BEGIN = "GET_HDF_CONFIGURATION_BEGIN";
export const GET_HDF_CONFIGURATION_SUCCESS = "GET_HDF_CONFIGURATION_SUCCESS";
export const GET_HDF_CONFIGURATION_ERROR = "GET_HDF_CONFIGURATION_ERROR";

export const SAVE_GENERAL_HDF_BEGIN = "SAVE_GENERAL_HDF_BEGIN";
export const SAVE_GENERAL_HDF_SUCCESS = "SAVE_GENERAL_HDF_SUCCESS";
export const SAVE_GENERAL_HDF_ERROR = "SAVE_GENERAL_HDF_ERROR";

const filterMemberHistory = obj => {
  return Object.entries(obj)
    .filter(([key]) => key.startsWith("memberHistory_"))
    .reduce((result, [key, value]) => {
      if (value) {
        result[key] = value;
      }
      return result;
    }, {});
};

const filterNonMemberHistory = obj => {
  return Object.entries(obj)
    .filter(([key]) => !key.startsWith("memberHistory_"))
    .reduce((result, [key, value]) => {
      result[key] = value;
      return result;
    }, {});
};

const renumberMemberHistory = obj => {
  // Create a temporary object to group related fields
  const grouped = {};
  const regex = /memberHistory_(\d+)_(.+)/;

  // Group related fields by their numbers
  for (const key in obj) {
    const match = regex.exec(key);
    if (match) {
      const [, number, field] = match;
      if (!grouped[number]) {
        grouped[number] = {};
      }
      grouped[number][field] = obj[key];
    }
  }

  // Convert to array and sort by original numbers
  const entries = Object.entries(grouped).sort((a, b) => a[0] - b[0]);

  // Create final object with sequential numbers
  const result = {};
  entries.forEach(([_, fields], index) => {
    const newNumber = index + 1;
    for (const [field, value] of Object.entries(fields)) {
      result[`memberHistory_${newNumber}_${field}`] = value;
    }
  });

  return result;
};

export const getHDFConfiguration = hdfId => {
  return dispatch => {
    dispatch({ type: GET_HDF_CONFIGURATION_BEGIN, payload: null });
    api
      .getHDFConfiguration(hdfId)
      .then(res => {
        dispatch({
          type: GET_HDF_CONFIGURATION_SUCCESS,
          payload: res.body,
        });
      })
      .catch(err => {
        dispatch({
          type: GET_HDF_CONFIGURATION_ERROR,
          payload: err.response ? err.response.body : err,
        });
      });
  };
};

export const submitHdf = (data, dispatch, props) => {
  const memberHistoryFields = filterMemberHistory(data);
  const nonMemberHistoryFields = filterNonMemberHistory(data);
  const renumberedHistoryFields = renumberMemberHistory(memberHistoryFields);
  const isLastPage = props.isLastPage;
  const cleanData = { ...nonMemberHistoryFields, ...renumberedHistoryFields };

  dispatch({ type: SAVE_GENERAL_HDF_BEGIN, payload: null });
  api
    .saveGeneralHDF(cleanData, isLastPage)
    .then(res => {
      dispatch({
        type: SAVE_GENERAL_HDF_SUCCESS,
        payload: { formData: cleanData, isCompleted: isLastPage },
      });
      if (isLastPage) {
        setTimeout(() => {
          alert("Your Health Declaration Form is submitted successfully.");
          window.close();
        }, 500);
      }
    })
    .catch(err => {
      dispatch({
        type: SAVE_GENERAL_HDF_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/actions.js